import { Button } from '@99designs/common/components/Button';
import React from 'react';

interface Props {
    userId: number;
}

const UserProfileButton = ({ userId }: Props) => (
    <Button
        variations={['marketing-secondary', 'chameleon', 'fluid', 'jumbo']}
        href={`/profiles/${userId}`}
    >
        {__('View portfolio')}
    </Button>
);

export default UserProfileButton;



// WEBPACK FOOTER //
// ./src/js/components/UserProfileButton.tsx